(() => {
  if (window.__hfPopupBlockInitialized) return;
  window.__hfPopupBlockInitialized = true;

  const OPENER_SELECTOR = '.product-popup-modal__opener[data-popup-block]';

  const norm = (value) =>
    (value || '')
      .toString()
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

  function isVisible(el) {
    if (!el) return false;
    const style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return el.getClientRects().length > 0;
  }

  function getScopeRoot(opener) {
    return (
      opener?.closest('.product__info-wrapper') ||
      opener?.closest('.product__info-container') ||
      opener?.closest('.featured-product') ||
      opener?.closest('.product') ||
      document
    );
  }

  function getConfig(opener) {
    return {
      enabled: opener?.dataset.reposition === 'true',
      names: (opener?.dataset.repositionName || '')
        .split(',')
        .map((value) => norm(value))
        .filter(Boolean),
    };
  }

  function findLegend(scopeRoot, candidates) {
    if (!scopeRoot || !candidates.length) return null;

    const fieldsets = scopeRoot.querySelectorAll('fieldset, .product-form__input');
    for (const fieldset of fieldsets) {
      if (!isVisible(fieldset)) continue;

      const legend = fieldset.querySelector('legend, .form__label');
      if (!legend || !isVisible(legend)) continue;

      const legendText = norm(legend.textContent);
      if (!legendText) continue;

      if (candidates.some((candidate) => legendText.includes(candidate) || candidate.includes(legendText))) {
        return legend;
      }
    }

    return null;
  }

  function placeRightInLegend(opener, legend) {
    if (!opener || !legend) return false;

    legend.style.display = 'flex';
    legend.style.alignItems = 'center';
    legend.style.width = '100%';
    legend.style.flexWrap = 'wrap';
    legend.style.columnGap = '8px';

    if (opener.parentElement !== legend) {
      legend.appendChild(opener);
    }

    opener.style.position = 'static';
    opener.style.display = 'inline-flex';
    opener.style.width = 'auto';
    opener.style.marginTop = '0';
    opener.style.marginBottom = '0';
    opener.style.marginLeft = 'auto';
    opener.style.justifyContent = 'flex-end';
    opener.style.flexShrink = '0';

    return true;
  }

  function placeAsBlock(opener) {
    if (!opener) return;

    const anchorId = opener.dataset.anchorId;
    const anchor = anchorId ? document.getElementById(anchorId) : null;

    if (anchor?.parentNode && opener.nextElementSibling !== anchor) {
      anchor.parentNode.insertBefore(opener, anchor);
    }

    opener.style.position = '';
    opener.style.display = '';
    opener.style.width = '';
    opener.style.marginTop = '';
    opener.style.marginBottom = '';
    opener.style.marginLeft = '';
    opener.style.justifyContent = '';
    opener.style.flexShrink = '';
  }

  function injectOpener(opener) {
    if (!opener) return;

    const { enabled, names } = getConfig(opener);
    if (enabled) {
      const legend = findLegend(getScopeRoot(opener), names);
      if (legend && placeRightInLegend(opener, legend)) return;
    }

    placeAsBlock(opener);
  }

  function scheduleInject(opener, delay = 80) {
    if (!opener) return;
    window.clearTimeout(opener.__hfPopupInjectTimer);
    opener.__hfPopupInjectTimer = window.setTimeout(() => {
      injectOpener(opener);
    }, delay);
  }

  function injectAll(delay = 0) {
    document.querySelectorAll(OPENER_SELECTOR).forEach((opener) => {
      if (delay > 0) {
        scheduleInject(opener, delay);
      } else {
        injectOpener(opener);
      }
    });
  }

  function boot() {
    injectAll();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try {
        subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, () => injectAll(80));
        subscribe(PUB_SUB_EVENTS.variantChange, () => injectAll(80));
      } catch (error) {}
    }

    ['variant:change', 'shopify:section:load', 'shopify:section:select', 'cart:item:added', 'cart:updated', 'ajaxCart:updated'].forEach(
      (eventName) => {
        document.addEventListener(
          eventName,
          () => {
            injectAll(80);
          },
          true
        );
      }
    );

    const host = document.getElementById('MainContent') || document.body;
    if (host) {
      new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'childList' && mutation.addedNodes?.length) {
            injectAll(80);
            break;
          }
        }
      }).observe(host, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  function openDesignPopup(el, attempts) {
    attempts = attempts || 0;
    if (!el || !el.isConnected) return;
    var modalId = el.dataset.popupId;
    if (!modalId) return;

    var modals = document.querySelectorAll('modal-dialog[id="' + modalId + '"]');
    for (var i = 0; i < modals.length - 1; i++) {
      try { modals[i].remove(); } catch (_) {}
    }

    var modal = modals[modals.length - 1];
    if (!modal || typeof modal.show !== 'function') {
      if (attempts < 20) {
        setTimeout(function () { openDesignPopup(el, attempts + 1); }, 80);
      }
      return;
    }
    var openerId = el.dataset.openerId;
    var opener = openerId ? document.getElementById(openerId) : null;
    try { modal.show(opener || document.body); } catch (_) {}
  }

  function closeDesignPopup(modalId) {
    if (!modalId) return;
    var modal = document.getElementById(modalId);
    if (!modal) return;
    try {
      if (typeof modal.hide === 'function') modal.hide();
      else modal.removeAttribute('open');
    } catch (_) {}
  }

  function refreshAllDesignPopups() {
    document.querySelectorAll('hf-popup-design-mode').forEach(function (el) {
      openDesignPopup(el);
    });
  }

  if (!customElements.get('hf-popup-design-mode')) {
    class HfPopupDesignMode extends HTMLElement {
      connectedCallback() {
        var self = this;
        var run = function () { openDesignPopup(self); };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', run, { once: true });
        } else {
          requestAnimationFrame(run);
        }
      }

      disconnectedCallback() {
        closeDesignPopup(this.dataset.popupId);
      }
    }
    customElements.define('hf-popup-design-mode', HfPopupDesignMode);
  }

  ['shopify:section:load', 'shopify:block:select', 'shopify:block:deselect'].forEach(function (ev) {
    document.addEventListener(ev, function () {
      setTimeout(refreshAllDesignPopups, 60);
    });
  });
})();
